import { Row, Typography, Button, Card } from "antd"
import { getCurrentDate } from "../../utils/formatters"
import { useMemo } from "react"

const { Text } = Typography

function LeadIn({ merchant, lead, setIsLeadIn }) {
  const monthText = useMemo(() => {
    if (Number(lead?.cart?.total) >= 360) {
      return 12
    } else {
      return 6
    }
  }, [lead])

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        maxWidth: 400,
        width: "100%",
        margin: "0 auto",
        padding: 20,
      }}
    >
      <div style={{ fontSize: 15 }}>
        <Text strong>Flexible Financing</Text> : Citi and other lenders through
        PayPossible{" "}
        {merchant?.code === "icon" && (
          <img src={"/icon-flex-pay.jpg"} width="30%" alt="icon-flex-pay" />
        )}
      </div>
      <div
        style={{
          border: "1px solid #5b96c5",
          borderRadius: 10,
          padding: 15,
          width: "100%",
          marginTop: 20,
        }}
      >
        <Row align="middle" justify="space-around">
          <img src={"/lenders/citi.png"} width="30%" alt="merchant-logo" />
          <div
            style={{
              border: "1px solid #5b96c5",
              borderLeftWidth: 0,
              borderRightWidth: 0,
              borderTopWidth: 0,
              paddingBottom: 5,
            }}
          >
            Sample offer from <strong>Citi Pay®</strong> Credit¹
          </div>
        </Row>
        <div style={{ fontWeight: 600, marginTop: 10 }}>
          No interest financing on $
          {Number(lead?.cart?.total) >= 360 ? 360 : 180}+ purchases, if paid in
          full within {monthText} mos².
        </div>
        <div style={{ marginTop: 10 }}>
          Interest will be charged to your account from the purchase date if the
          purchase balance is not paid in full within {monthText} months.
        </div>
      </div>
      <Row
        align="middle"
        justify="space-between"
        style={{
          padding: 10,
          fontWeight: 600,
        }}
      >
        <div>Purchase Amount:</div>
        <div>$ {lead?.cart?.total.toLocaleString()}</div>
      </Row>
      <Row
        align="middle"
        justify="space-between"
        style={{
          padding: 10,
          fontWeight: 600,
        }}
      >
        <div>Sugg. Payments:</div>
        <div>$ {Number(lead?.cart?.total / monthText).toFixed(2)} / mo</div>
      </Row>
      <Row
        align="middle"
        justify="space-between"
        style={{
          padding: 10,
          fontWeight: 600,
        }}
      >
        <div>Term:</div>
        <div>{monthText} mos</div>
      </Row>
      <Row
        align="middle"
        justify="center"
        style={{
          marginTop: 20,
        }}
      >
        <Button type="primary" size="large" onClick={() => setIsLeadIn(false)}>
          Get Started
        </Button>
      </Row>
      <Card
        bodyStyle={{
          paddingBottom: 0,
          paddingRight: 10,
          paddingLeft: 10,
        }}
        style={{
          width: "100%",
          maxHeight: 250,
          height: "100%",
          overflowY: "auto",
          marginTop: 20,
        }}
      >
        <div
          style={{
            fontWeight: 600,
            fontSize: 20,
            marginBottom: 20,
            textAlign: "center",
          }}
        >
          Disclosures
        </div>
        <div style={{ fontWeight: 400, fontSize: 15 }}>
          (1) This is an example of an offer that may be available from our
          lending partner, Citi. If you do not pre-qualify for Citi Pay Credit,
          PayPossible may share your application information with other
          financial providers to see if you may be eligible for other financing
          options.
          <br />
          <br />
          (2) Subject to credit approval. No interest if paid in full within the
          promotional period. Interest will be charged to your account if the
          purchase balance is not paid in full within the promotional period.
          <br />
          <br />
          This Deferred Interest Plan purchase is subject to the following
          promotional terms: you will not be charged any interest on the amount
          of the purchase if that amount is paid in full within 12 months.
          <br />
          <br />
          If the amount of the purchase is not paid in full by the end of the
          promotional period, interest charges will be imposed from the purchase
          date at the purchase amount, which is 33.24% APR. This APR is accurate
          as of {getCurrentDate()}. This APR is variable and will vary with the
          market based on the Prime Rate.
          <br />
          Your Card Agreement, this Promotional Disclosure and applicable law
          govern the terms of this Deferred Interest Plan purchase.
          <br />
          <br />
          The suggested monthly payment stated is an estimate based on listed
          purchase amount divided by the number of months in the promotional
          period. It excludes sales tax, is rounded to the next highest cent and
          does not include additional payments that may be required for an
          existing balance or future purchases. In order to pay your promotional
          balance by the end of the period you may have to make a payment each
          month that is higher than your required minimum payment.
        </div>
      </Card>
    </div>
  )
}

export default LeadIn
